import { useTenantConfigQuery } from './useTenantConfigQuery';

export const useTenantVenueConfig = (countryCode?: string) => {
  const { data: config } = useTenantConfigQuery(countryCode);

  return {
    franchises: config?.venueConfig?.supportedFranchises ?? [],
  };
};
